export default {"src":"/_next/static/media/csv.cac8e2b4.svg","height":512,"width":513};